import React, { useContext, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Title, Subtitle, AddButton, ButtonAdorned,
} from '@components/atoms';
import {
  Grid, Divider, Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import i18n from '@i18n';
import AuthContext from '@contexts/AuthContext';
import List from './List';
import Create from './Create';
import EditAnalisis from './EditAnalisis';
import Edit from './Edit';

const Roles = ({ location: { search }, match: { params: { action = 'list', id = '' } } }) => {
  const { pages: { employees: { roles: texts } } } = i18n;
  const classes = useStyles();
  const history = useHistory();
  const { user } = useContext(AuthContext);

  const handleAddClick = () => {
    history.push('/e/roles/create');
  };

  const handleAddClickIngreso = () => {
    history.push('/e/roles/analisis');
  };

  const [extraInfo, setExtraInfo] = useState([]);

  return (
    <>
      <Helmet>
        <title>{`${i18n.appName} - ${texts.title}`}</title>
      </Helmet>
      <Grid
        container
        spacing={0}
        className={classes.container}
        alignItems="center"
      >
        {texts.title && (
        <Grid item xs={12} sm={3} align="left">
          <Title>{texts.title}</Title>
        </Grid>
        )}
        {action === 'list' && user && user.permissions.roles.create && (
        <Grid item xs={12} sm={9} align="right" className={classes.root}>
          <ButtonAdorned color="secondary" onClick={handleAddClickIngreso}>{texts.ingreso}</ButtonAdorned>
          <AddButton onClick={handleAddClick}>{texts.add}</AddButton>
        </Grid>
        )}

        {(action === 'view' || action === 'edit') && (
          <Grid item xs={12} sm={9} align="right">
            {extraInfo.map((info) => <Typography key={info}>{info}</Typography>)}
          </Grid>
        )}
      </Grid>
      {texts.subtitle && (
        <Grid container spacing={0} className={classes.container}>
          <Grid item xs={12} align="left">
            <Subtitle>{texts.subtitle}</Subtitle>
          </Grid>
        </Grid>
      )}
      <Divider />
      <div className={classes.container}>
        {action === 'list' && user && user.permissions.roles.read && <List search={search} />}
        {action === 'create' && user && user.permissions.roles.create && <Create />}
        {action === 'analisis' && user && user.permissions.roles.update && <EditAnalisis />}
        {action === 'edit' && user && user.permissions.roles.update && <Edit id={id} setExtraInfo={setExtraInfo} />}
      </div>
      <Divider />
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  mt1: {
    marginTop: '1em',
  },
  container: {
    padding: theme.spacing(3),
  },
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
}));

Roles.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      action: PropTypes.string,
      id: PropTypes.string,
    }),
  }),
};

Roles.defaultProps = {
  location: {
    search: '',
  },
  match: {
    params: {
      action: 'list',
      id: '',
    },
  },
};

export default Roles;
